import { useState, useEffect } from 'react';
export function useOnScreen(ref, rootMargin, useDependencies) {
  if (rootMargin === void 0) {
    rootMargin = '0px';
  }

  if (useDependencies === void 0) {
    useDependencies = false;
  } // State and setter for storing whether element is visible


  var _a = useState(false),
      isIntersecting = _a[0],
      setIntersecting = _a[1];

  useEffect(function () {
    var node = ref.current;
    var observer = new IntersectionObserver(function (_a) {
      var entry = _a[0]; // Update our state when observer callback fires

      setIntersecting(entry.isIntersecting);
    }, {
      rootMargin: rootMargin
    });

    if (ref.current) {
      observer.observe(node);
    }

    return function () {
      observer.unobserve(node);
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  useDependencies ? [ref, rootMargin] : []);
  return isIntersecting;
}